import { types } from "../type";

const initialState = {
  holidayResponse: "",
  holidayError: "",
  holidayLoading: false,
  holidayStatus: 0,
  locationId: ""
};

const holidayReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.HolidayTypes.HOLIDAY_SET_LOADING:
      return {
        ...state,
        holidayLoading: action.payload
      };

    case types.HolidayTypes.HOLIDAY_CLEAR_ERRORS:
      return {
        ...state,
        holidayError: ""
      };
    case types.HolidayTypes.HOLIDAY_GET_ERRORS:
      return {
        ...state,
        holidayLoading: false,
        holidayError: action.payload.data.message,
        holidayStatus: action.payload.status
      };
    case types.HolidayTypes.HOLIDAY_CLEAR_RESULT:
      return {
        ...state,
        holidayResponse: ""
      };
    case types.HolidayTypes.ADD_HOLIDAY_LIST:
      return {
        ...state,
        holidayLoading: false,
        holidayResponse: action.payload.message
      };
    default:
      return state;
  }
};

export default holidayReducer;
